import { LuMessageSquareMore } from "react-icons/lu";
import { LiaViber, LiaWhatsapp } from "react-icons/lia";
import { HiOutlineMail } from "react-icons/hi";

export const channelColors = {
  sms: "black",
  viber: "purple",
  whatsapp: "green",
  email: "black",
};

export const channelIcons = {
  sms: (
    <LuMessageSquareMore
      size={30}
      className="p-[3px]"
      color={channelColors.sms}
    />
  ),
  viber: <LiaViber size={30} color={channelColors.viber} />,
  whatsapp: <LiaWhatsapp size={30} color={channelColors.whatsapp} />,
  email: (
    <HiOutlineMail size={30} className="p-[3px]" color={channelColors.email} />
  ),
};
